module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/plainclothesnaked_con#ch_05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FIVE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Manny could not take his eyes off the straw. Tina kept it lodged in the left side of her mouth, between a gap in her teeth. A splotch of chocolate dotted her lip, and he resisted the urge to reach over and wipe it away. Instead, he glanced out the window, fixating on the Golden Arches, which weren’t gold at all. Which were, in fact, a vitamin-rich urine yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“McDonald’s,” Tina said, when she’d sucked her way to the bottom of her shake. “I bet you’re a regular charm-pot with the ladies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“This isn’t a date,” Manny said, returning her gaze and keeping things bland.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, it’s not!” Tina threw herself back in the booth. “Gee, Mistuh Powiceman, I thought you wiked me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny sighed and pushed the stirrer around in his "), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("coffee. It tasted like watered-down transmission fluid. He hadn’t known he was going to ask her out until he did. This raised the eyebrows of the chubby evidence guys, but Manny’d made a show of tapping his nose behind Tina’s back, letting the hair-pluckers know he thought she was hinky. Though he wasn’t sure he did. In fact, it was just the opposite. There was something about her that made "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(" feel guilty. But he didn’t need to share that with Tweedledee and Tweedledum. They might not understand existential angst.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“I hate baby talk,” Tina blurted suddenly. “Marvin thought it was cute.” She plucked the straw from her mouth and threw it at him. “What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny considered, decided to ignore the question, and waited to see if she’d say more. When she didn’t, he leaned toward her over the table. “Nothin’ personal, but I don’t see you with a Marvin. Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" Marvin specifically, just, you know, any Marvin. You don’t look like the Marvin type.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You never know until you get there,” she shrugged. “Besides, I’m not gonna tell you I didn’t like the guy. He was a train wreck. But he didn’t start off that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Do they ever?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny did his staring-off thing, letting his eyes fall on the French Fry boy, a sloe-eyed stringbean named Lance. He’d popped him a few years ago for planting a bug in the women’s rest room of an Exxon station. Lance was caught sneaking in to remove the tape. It wasn’t the most sophisticated setup: a sound-activated microcassette super-glued under the sink. What intrigued Manny was the kind of charge a fourteen-year-old got from listening to strange women relieve themselves. It wasn’t until he interviewed the family that he found out the truth. Mommy French Fry had a thing for the station owner, a wiry Egyptian named Haik. She and Haik liked to sneak off for romantic little Exxon trysts. The boy wanted to play the evidence to Daddy, who worked three jobs so his wife could stay home and watch the kids. Unfortunately, by the time Manny’d made his discovery, Lance was already outted. His junior high paper ran a story: "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("POLICE NAB POOPER SCOOPER")]), _vm._v("!—and the scorn was so harsh Lance dropped out. Since then, he’d joined the glamorous world of fast-food preparation. Where he was clearly thriving.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When Manny thought he’d ignored her long enough, he turned back to Tina, who was shaking her head. “My luck,” she said, “I get a cop with A.D.D. Does your insurance cover Ritalin, or are we stuck here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I was just thinking,” Manny lied.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Anything good? ’Cause much as I love watching you cogitate, I’ve got a lot of loose ends to tie up back at my house. My husband just died, in case you forgot.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I didn’t forget. That’s what I was thinking about. How whatever happened happened. You realize everybody’s gonna pretty much assume you did it, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina appeared to size him up for a moment, her face tightening, then did the exact opposite of what he thought she’d do. He expected denials, flight, maybe a milkshake flung at his head. Instead—and now he was really hooked—she laughed in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What are we, on TV? You think I’m gonna roll over and say ‘Please Daddy Cop-man, don’t hurt me?’”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What I think is that a guy who was gonna drink drain cleaner wouldn’t bother to pour it over his cereal, you know what I mean? I’ve seen foamers before. A guy’s gonna go out that way, he doesn’t get gourmet about it. He just guzzles.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina shrugged. “Marvin was kind of a roughage freak. Maybe he wanted to make sure he was regular in the afterlife. Say what you will about Lucky Charms, they go right through you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is that true?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, I don’t know from experience. I don’t eat breakfast. I need to be up a while before I can chew and swallow. But from what Marv said, the stuff got the job done.” She paused to pull a pack of Viceroys out of her purse. She flipped one out, tore the filter off, and lit up in a single motion.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You know you can’t smoke here,” said Manny, though he loved that she’d just gone ahead and fired one up. A family of overweight towheads at the next table was already grumbling “Mickey D’s is a wholesome place.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Her response was a smoke ring the size of a Krispy Kreme blown straight at his nose, followed by another that floated through the first. “You’re about to bust me for breakfast food murder, and I’m supposed ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("to worry about smoking in public? What’s that gonna get me, an extra half hour on top of life?”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Manny smiled and sipped his transmission fluid. He was such a sucker for women with balls.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina flicked ash in his coffee. “So you gonna arrest me or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Just then the McDonald’s manager, a serious Asian fellow with "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WING")]), _vm._v(" on his nametag, stepped smartly up to their table. He stopped cold when he saw the look on Tina’s face. “I’m on medication,” she said to him. “If I don’t smoke cigarettes I break things.” Wing looked at Manny, who busied himself picking ash out of his coffee. The manager remembered him from his uniform days. People were always expecting the police to solve their problems.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Where were we?” she said, when the young fast-food exec was safely back behind his counter.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You asked if I was going to arrest you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was a question Manny’d been sidestepping since she’d told him he’d better have a hard ass.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That depends,” he said, more cautiously than he’d intended.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina picked up her shake and tipped the last of it down her throat, tapping the bottom. “On what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He didn’t have an answer, so he just stared at her, furrowing his brows and squinting as though deeper meaning were just oozing out of him. In his mind he looked like Clint Eastwood, but something told him it stopped there.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina fixed him with a mirthless smile. “That something you practice in front of the mirror, or they teach that ‘Look at me, I’m deep’ look at the academy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Tell you the truth, I forget,” he said. “I only went ’cause I couldn’t get into Clown College. I’m actually pretty fucking sick of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You lookin’ to get out?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She regarded him as much with curiosity as anything else. If she’d reached under the table and rubbed his thigh, or licked her lips, he’d have pegged her as another perpette trying to slut her way out of a fall. But Tina was different. She was just laying it out. He got that tingle in the back of his head again. Only this time his fear had a friend. A little pal called lust.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("After their snack,")]), _vm._v(" Manny steered back to Carmichael Street in a preoccupied haze. Tina must have been staring at him for a while before he noticed, and when he did, she still didn’t speak.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What?” said Manny finally. They slowed to a stop sign a block from her house.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I want to show you something, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Detective,")]), _vm._v(" but I don’t know if you want to see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Try me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I would, but you don’t know what it is. Maybe I shouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You trying to make me beg?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny sat back in the seat and rubbed his neck. His car, an unmarked Impala the color of mayonnaise, had been issued previously to a Pittsburgh P.D. lieutenant in Vice named Hanes. (Upper Marilyn got most of its equipment, and some its employees, used.) Hanes’s claim to fame was a ten-year lawsuit that kept him on the force despite tipping the scales at 390. What the mammoth vice dick’s behind had done to the seat of the Impala was fairly predictable. For Manny, it was like riding in a bomb crater, but the seat-back was worse. His spine sort of curved in, where the stuffing had been smashed down to the springs. No amount of adjusting could make it bearable. There wasn’t a Comfy Cushion, Sacro-Ease, or inflatable pillow invented that countered the discomfort of sitting in the fat detective’s divot.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was the Hanes seat-crater, as much as anything, that made him say yes—or at least “Why the fuck not?”—when Tina made her proposition. He’d been pleading with the department for a new car for two years.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Okay, pull over,” she said, when the house was in sight. She was already fishing in her purse.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Part of Manny worried someone might see him sitting with a possible perp. But it wasn’t like she had her head between his legs—he wasn’t the sex-for-favors type. They weren’t even touching. Besides which, detectives had a lot of leeway when it came to “freshies,” suspects close enough to the crime to still be freaked out about it. (As a rule this meant being caught, if not red-handed, then right after a crime had been discovered, in situations too ludicrous to explain by ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("coincidence: the teen with panties in his pocket, outside the dorm where three cheerleaders had been raped; the lug with the diamond choker in his ashtray, geezing speed in a clunker three blocks from the broken-in jeweler’s.) In freshy-state, souls were more likely to spill than they were when they’d had time to mull.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Manny himself was famous for bonding with suspects. He’d once dined at Der Wienerschnitzel with a man found on the scene at a mosque-defacing. Midway through his bratwurst, the fellow confessed that he’d hated Moslems ever since an unscrupulous Armenian sold his ex–father-in-law a bad toupee. Just recounting it got him furious. “The thing slipped off at our wedding dinner, right into the lobster bisque. After that, the whole thing was a joke. Whenever anybody mentions my wedding, they never mention how pretty the bride looked, or the beautiful service…. Never! It’s always, ‘Ha-ha, remember when Mr. Depew’s rug slipped in the bisque!’ Ha-fucking-ha! I bet we wouldn’t even be divorced if that camel-kisser hadn’t sold us the crappy rug!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When Manny pointed out that Armenians weren’t actually Arab, that they pretty much hailed from Europe—though, admittedly, some oddball corner of it—Depew’s ex–son-in-law dropped his head onto his bratwurst and began to weep. “Now there’ll be a jihad….”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Happily, Manny’d got the DA to recommend a psychiatric work-up and community service.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You sure you’re ready?” asked Tina, when he finally finessed the Chevy within shouting distance of the curb. “I always heard cops can’t parallel park. I mean, why should they learn? It’s not like anybody’s gonna give them a ticket, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s not true,” Manny said. “Sometimes I give them to myself, just to keep me honest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is that right?” Tina had the envelope in her hand, and a look in her eye that said ‘Fuck with me now and I’ll kill you, too.’ In that moment, Manny had to admit, he was so in love it hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What I’m gonna show you,” she began, then stopped and fired up another filter-ripped Viceroy. When she started talking again, she aimed her gaze straight ahead, at the back of the red minivan in front of them. A bumper sticker on the window said "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("I BRAKE FOR JESUS")]), _vm._v(".")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("“What I’m going to show you, I had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nothing")]), _vm._v(" to do with, okay?” She ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("chose her words carefully, “I found it, but it wasn’t something I was supposed to find.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“You mean you stole it,” Manny said mildly. Always mildly, when coaching your way through a perp chat. “You didn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("buy")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("create")]), _vm._v(" the thing, you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("stole")]), _vm._v(" the thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Technically, yes,” said Tina, with new respect. “But I don’t know who I stole it from. As long as you understand that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I do,” he said, and slid the manila envelope out of her hand before she changed her mind. She stayed on him, wide-eyed, itching to see his reaction when he pulled what was inside out. But he didn’t want to give her the thrill. Not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m just wondering, did Marvin have anything to do with what I’m about to look at? Was this one of his scams?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Marvin?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina rolled down the window and tossed her hardly smoked cigarette onto somebody’s lawn. It looked like AstroTurf, with bald spots. “Marvin had nothing to do with this,” she said. “Marvin was an accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’ve had a few of those,” Manny sighed, catching himself when he realized just what she might think he was saying. “I mean, I’ve been in a relationship with the wrong person, I don’t mean I’ve been in a relationship with them and left them slumped in a bowl of Grape-Nuts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Lucky Charms,” said Tina, “but I hear what you’re saying.” She met his gaze in a way that made his brain buzz. “When it comes to romance, you’re a fuck-up, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny hadn’t exactly ever looked in the mirror and yelped this at himself, but hearing it now, it sounded true.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well,” he said, “one divorce, a handful of quasimonogamous nightmares, and here I am, getting cozy with a murder suspect. I’d say my track record speaks for itself.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("Tina turned away, and Manny had a feeling she was staring at her own reflection in the passenger window, or staring at his. When she spoke again her voice was flatter, somewhere between weary and serene. “I always start out liking guys for one thing, and when I find out the thing I liked them for isn’t real, I sort of hang around pretending it is—or trying to make it that way. Like with Marvin. When I met him, he was this wild-eyed entrepreneur type. The guy had all kinds of ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("ideas. He was making crazy money off them. I thought he was a genius.”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Was he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sometimes,” said Tina. “Other times he was a total Mongoloid. When he made some dough on one crackpot idea, he’d blow it all on three other ones. His new thing, he was an on-line money guru. Literally. He videoed himself in loincloth and turban, like Gandhi with a potbelly, giving financial advice. Then he switched from investment tips to chanting for money. He cooked up these special mantras.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Om nyoho renge cash?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Basically. Except we didn’t have any money, which didn’t say much for his cash-chanting efficiency. I could never pin him down, though. He was so enthusiastic, you just kind of wanted everything to work. That’s what I loved about him. Until…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She faltered, and Manny had to prompt her. “Until?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Until he started chanting through his nose, and I had to listen to him snuffle and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Om")]), _vm._v(" all day like a monk with a harelip. That’s what put me over the edge. Hangovers are bad enough without Hindu sound effects.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny’s ears burned, the way they did when people’s words slipped into the Red Zone: when they were confessing, whether they knew it or not. The air between them had gone electric.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“There’s always something like that,” he said, too casually, “something you don’t expect that comes along and changes everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tina rested the tip of one forefinger on the back of his wrist. No more than that, and it was more than he could remember feeling since he was thirteen.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The nose-humming was pretty much out of the blue,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I rest my case,” said Manny, and ripped open the envelope.")])])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page38"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b69076","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plainclothesnaked_ch05.vue
// module id = 87
// module chunks = 0